import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import VisitorTracker from "@/components/VisitorTracker";
import Home from "@/pages/Home";
import WhyHireUs from "@/pages/WhyHireUs";
import MarketingProcess from "@/pages/MarketingProcess";
import ManagementProcess from "@/pages/ManagementProcess";
import OwnersFAQ from "@/pages/OwnersFAQ";
import RentersFAQ from "@/pages/RentersFAQ";
import GetFreeAnalysis from "@/pages/GetFreeAnalysis";
import Analytics from "@/pages/Analytics";
import "@/App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <VisitorTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/why-hire-us" element={<WhyHireUs />} />
          <Route path="/marketing-process" element={<MarketingProcess />} />
          <Route path="/management-process" element={<ManagementProcess />} />
          <Route path="/owners-faq" element={<OwnersFAQ />} />
          <Route path="/renters-faq" element={<RentersFAQ />} />
          <Route path="/get-free-analysis" element={<GetFreeAnalysis />} />
          <Route path="/admin/analytics" element={<Analytics />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
